module.exports = __webpack_public_path__ + "static/media/BG_42.e501b439.png";